import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ChooseProductTagContainer = styled('div')`
  margin-left: unset;
  flex-wrap: nowrap;
  display: flex;
  align-items: flex-start;
  gap: ${spacing('sm')};
  em:not(:last-child) {
    margin-right: ${spacing(2.5)};
  }
  @media ${media.minWidth.sm} {
    margin-left: auto;
    justify-content: end;
  }
`;

export const $ChooseProductTagOpenFileContainer = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;
  em {
    margin-right: unset !important;
  }
  a {
    color: ${({ theme }) => theme.colors.paragraphTextColor};
    text-decoration-color: ${({ theme }) => theme.colors.paragraphTextColor};
  }
`;
